export default __webpack_public_path__ + "static/media/gallery_03.9841fec0.jpg";